<h2 class="confirm-dialog__title" mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="confirm-dialog__message">
	{{ data.message }}
</mat-dialog-content>

<mat-dialog-actions class="confirm-dialog__actions">
	<button type="button" class="confirm-dialog__cancel" (click)="cancel()">
		{{ cancelText }}
	</button>
	<button
		type="button"
		class="confirm-dialog__confirm"
		[class.confirm-dialog__confirm--destructive]="data.destructive"
		cdkFocusInitial
		(click)="confirm()"
	>
		{{ confirmText }}
	</button>
</mat-dialog-actions>
